import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import {
  Box,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import type { DiningPolicySection_booking$key } from "./__generated__/DiningPolicySection_booking.graphql";

type Props = {
  bookingRef: DiningPolicySection_booking$key | null;
};

export const DiningPolicySection = ({ bookingRef }: Props) => {
  const booking = useFragment(DiningPolicySectionFragment, bookingRef);

  if (!booking?.policy) {
    return null;
  }

  return (
    <Box padding={5} gap={3} backgroundColor="surface-primary">
      <VStack gap={2}>
        <Text variant="mainHeading">{t`Dining Policy`}</Text>
        <Text variant="mainBaseMedium" color="text-primary">
          {booking.policy}
        </Text>
      </VStack>
    </Box>
  );
};

export const DiningPolicySectionFragment = graphql`
  fragment DiningPolicySection_booking on Booking {
    ... on DiningBooking {
      policy
    }
  }
`;
